import { useNavigate } from "@tanstack/react-router";
import { IconArrowLeft, IconPlus } from "@tabler/icons-react";
import { AdminPageHeader, Button, Group } from "@/components/ui";
import { MapeosImportarExcel } from "./MapeosImportarExcel";

export function MapeosHeader({
  total,
  modoCrear,
  onIniciarCrear,
}: {
  total: number;
  modoCrear: boolean;
  onIniciarCrear: () => void;
}) {
  const navigate = useNavigate();
  return (
    <AdminPageHeader
      title="Cuentas por clave SAT"
      description={`${total} mapeos · relacionan la clave producto/servicio del SAT con la cuenta contable, para derivar la cuenta de cada renglón del prorrateo FB60 (equivalente de dbo.Tag).`}
      actions={
        <Group gap="xs">
          <Button variant="default" leftSection={<IconArrowLeft size={14} />} onClick={() => void navigate({ to: "/admin" })}>
            Volver
          </Button>
          <MapeosImportarExcel />
          {!modoCrear ? (
            <Button leftSection={<IconPlus size={14} />} onClick={onIniciarCrear}>
              Nueva cuenta por clave
            </Button>
          ) : null}
        </Group>
      }
    />
  );
}
